<form
    [formGroup]="registerFormService.form"
    (ngSubmit)="onSubmit()"
    class="space-y-4"
>
    <lib-user-info-form
        [theme]="'auth'"
        [disabled]="disabled()"
    ></lib-user-info-form>

    <!-- Terms Disclaimer -->
    <div class="pt-2 text-xs leading-relaxed text-slate-500">
        By registering, you agree to our
        <a
            routerLink="/terms"
            target="_blank"
            class="font-medium text-[#1587e8] transition hover:underline"
            >Terms of Service</a
        >
        and
        <a
            routerLink="/privacy"
            target="_blank"
            class="font-medium text-[#1587e8] transition hover:underline"
            >Privacy Policy</a
        >.
    </div>

    <!-- Submit Button -->
    <button
        type="submit"
        [disabled]="disabled()"
        class="hover: mt-2 flex w-full cursor-pointer items-center justify-center gap-2 rounded-xl bg-gradient-to-b from-[#1587e8] to-[#0f6ebd] py-3.5 text-sm font-semibold text-white shadow-[0_4px_14px_0_rgb(21,135,232,0.39)] ring-1 ring-white/20 transition-all duration-200 ring-inset hover:shadow-[0_6px_20px_rgba(21,135,232,0.23)] hover:brightness-110 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60"
    >
        @if (disabled()) {
            <svg
                class="h-4 w-4 animate-spin text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
            >
                <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                ></circle>
                <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
            </svg>
            <span>Creating Account...</span>
        } @else {
            <span>Create Account</span>
            <ng-icon
                name="lucideArrowRight"
                class="h-4 w-4 transition-transform group-hover:translate-x-0.5"
            />
        }
    </button>
</form>
